<template>
  <div class="catalogSubsetBannerSmall">
    <div>
      <img
        class="siteMap__pageItemShape"
        :src="require(`~/assets/img/catalog_subset_banner_small.svg`)"
        alt=""
      />
    </div>
    <div class="catalogSubsetBannerSmall__text">
      Zachęcamy do przejrzenia oferty i rozpoczęcia zakupów w
      <icon-link
        :to="
          localePath({
            name: 'dashboard-catalog-subset',
          })
        "
        text="minikatalogu"
        icon="chevron-right-bold"
      />
    </div>
  </div>
</template>

<script>
import IconLink from '@/components/IconLink.vue';

export default {
  name: 'CatalogSubsetBannerSmall',
  components: { IconLink },
};
</script>

<style lang="scss" scoped>
.catalogSubsetBannerSmall {
  display: flex;
  align-items: center;
  border: 1px solid $cAddLight;
  border-radius: 4px;
  padding: 1.5rem;
  margin-top: 2rem;

  &__text {
    color: $cMainNeutral;
    font-size: 1.4rem;
    line-height: 1.28;
    font-weight: 600;
    padding-left: 1.5rem;

    ::v-deep .iconLink {
      display: inline-flex;
    }
  }
}
</style>
